import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCalculator({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M13 .85c.97 0 1.75.78 1.75 1.75v10.79c0 .96-.78 1.75-1.75 1.75H3c-.97 0-1.75-.79-1.75-1.75V2.6c0-.97.78-1.75 1.75-1.75h10zm.25 5.25H2.75v7.29c0 .13.11.25.25.25h10c.14 0 .25-.12.25-.25V6.1zM5.5 10.3c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h1zm3 0c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h1zm3-3c.28 0 .5.22.5.5v4a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-4c0-.28.22-.5.5-.5h1zm-6 0c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h1zm3 0c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h1zM13 2.35H3a.25.25 0 00-.25.25v2h10.5v-2a.25.25 0 00-.25-.25z" />
    </svg>
  );
}

SvgBasicCalculator.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCalculator.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicCalculator svgRef={ref} {...props} />);
export default ForwardRef;
